import { useMemo } from 'react';

import {
    DEFAULT_CHUNK_SUMMARY_COL_DEF,
    getChunkSummaryColumnDefs,
    getChunkSummaryRowData,
} from './ChunkSummaryTable.constants';

export default function useGetChunkTableData(chunkResults, onViewChunk) {
    const rowData = useMemo(
        () => getChunkSummaryRowData(chunkResults),
        [chunkResults],
    );

    const columnDefs = useMemo(
        () => getChunkSummaryColumnDefs(onViewChunk),
        [onViewChunk],
    );

    return {
        rowData,
        columnDefs,
        defaultColDef: DEFAULT_CHUNK_SUMMARY_COL_DEF,
    };
}
